module.exports = __webpack_public_path__ + "img/sharing-folder.bba86af5.png";